import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequireAction } from "@/components/role-gate";

import { guardModuleRoute } from "@/lib/module-guard";

export const Route = createFileRoute("/billing")({
  beforeLoad: ({ location }) => guardModuleRoute(location.pathname),
  head: () => ({ meta: [{ title: "Billing · AVS Gold ERP" }] }),
  component: () => (
    <RequireAction action="billing.view" label="Billing">
      <Outlet />
    </RequireAction>
  ),
});
